import PropTypes from 'prop-types';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import styles from './FJImageExtenderRight.module.less';
import FJImageExtenderCreationsContainer from '../container/FJImageExtenderCreationsContainer';
import classNames from 'classnames';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';

const FJImageExtenderRight = props => {
    const { headerTabIndex, setIsDraggingFile, uploadImg } = props;

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            className={classNames(styles.app_right, headerTabIndex === 0 ? styles.creations_box : '')}
        >
            <FJDisplayHeaderContainer />

            <FJImageExtenderCreationsContainer active={headerTabIndex === 0} />

            <FJCreationPanelContainer activeHeaderTabIndex={1} hideCompare={true} />

            <FJHistoryPanelContainer activeHeaderTabIndex={2} />
        </FJDragBox>
    );
};

FJImageExtenderRight.propTypes = {
    headerTabIndex: PropTypes.number,
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
};

export default FJImageExtenderRight;
